module.exports = __webpack_public_path__ + "fonts/IBM_Plex_Sans-300-4.c50c4d9.woff2";